import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';

export const BudgetHeading = styled(Typography)`
  margin-top: -12px;
  margin-bottom: 5px;
`;

export const BudListing = styled(List)`
  border: 2px solid;
  border-radius: 10px;
  background-color: #ffffff;
  min-height: 8vh;
  padding: 5px 10px;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const InvoiceListing = styled(List)`
  border: 2px solid;
  border-radius: 10px;
  background-color: #ffffff;
  height: 48vh;
  padding: 5px 10px;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const CbpListHeading = styled(Typography)`
  margin-top: 8px;
  margin-bottom: 5px;
`;

export const ProgressCircular = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  height: 32vh;
  align-items: center;
`;
